import PackageJson from '../../package.json';

export const test = false;
export const { name } = PackageJson;
export const { version } = PackageJson;
export const google_map = true;
export const ga_id = 'UA-136378910-1';

// Production URL
let _url = 'https://api.carfillo.com';
// let _url = "http://172.172.60.137:8000";
// _url = "http://172.172.60.133:8004";

if (window.location.host === 'dev.carfillo.com') {
  // Develop URL
  _url = 'https://dev.api.carfillo.com';
}

export const BaseURL = _url;
// FOR TEST
// export const BaseURL = "http://127.0.0.1:8000";
// export const BaseURL = "https://dev.api.carfillo.com";
// -----------------------------------------------------
export const ShowPhone = '021 - 91008595';
export const Phone = 'tel:+982191008595';
export const Email = 'info@carfillo.com';
export const site_title = 'کارفیلو';
